import React, { useState, useEffect } from 'react';
import { useSession } from '@/lib/SessionContext';
import { Sparkles, X } from 'lucide-react';

const greetings = {
  developer: [
    "Halo Fadli! Sistem aman terkendali, siap tempur hari ini? 🚀",
    "Welcome back, Mas Dev! Semangat codingnya hari ini.",
    "Bismillah push code hari ini lancar jaya ya, Fadli! ✨",
  ],
  owner: [
    "Selamat datang, Fadli! Ada laporan keuangan yang mau dicek hari ini?",
    "Halo Fadli! Kas dan operasional hari ini terpantau aman terkendali. 💼",
    "Welcome! Semoga profit hari ini sesuai target ya! 🎯",
  ],
  finance: [
    "Halo tim Finance! Jangan lupa cek invoice jatuh tempo hari ini ya. 💰",
    "Selamat bekerja! Arus kas dan piutang siap dipantau. 📊",
  ],
  produksi: [
    "Halo tim Produksi! Mari kita cek sisa bahan baku dan PO hari ini. 🏭",
    "Semangat produksinya! Pastikan kualitas racikan selalu terjaga ya. ✨",
  ],
  default: [
    "Halo! Selamat bekerja, semoga hari ini berjalan lancar! ✨",
    "Welcome back! ASA siap membantu pekerjaanmu hari ini. 🤖",
  ]
};

export default function AsaGreetingWidget() {
  const { member } = useSession();
  const [greeting, setGreeting] = useState('');
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!member) return;
    
    // Check if we already greeted them today
    const today = new Date().toLocaleDateString();
    
    // Generate greeting based on role
    const roleKey = greetings[member.role] ? member.role : 'default';
    const templates = greetings[roleKey];
    
    // Pick deterministic but varied greeting based on today's date and user ID
    const seed = today.replace(/\D/g, '') + (member.id?.length || 0);
    const randomIndex = parseInt(seed) % templates.length;
    
    let timeGreeting = "Halo";
    const hour = new Date().getHours();
    if (hour < 11) timeGreeting = "Selamat Pagi";
    else if (hour < 15) timeGreeting = "Selamat Siang";
    else if (hour < 18) timeGreeting = "Selamat Sore";
    else timeGreeting = "Selamat Malam";

    let finalGreeting = templates[randomIndex].replace(/Halo|Welcome|Selamat datang/, timeGreeting);
    
    setGreeting(finalGreeting);
    
    // Show once per session
    const sessionGreeted = sessionStorage.getItem(`asa_greeted_widget_${member.id}`);
    if (sessionGreeted === today) {
      setVisible(false);
    } else {
      sessionStorage.setItem(`asa_greeted_widget_${member.id}`, today);
    }
    
  }, [member]);

  if (!visible || !member || !greeting) return null;

  return (
    <div className="bg-gradient-to-r from-[#F9F5EC] to-[#FFFDF9] border border-[#E6D5B8] rounded-xl md:rounded-2xl p-3 md:p-4 shadow-sm flex items-start sm:items-center gap-3 md:gap-4 relative animate-in fade-in slide-in-from-top-4 duration-700">
      <button 
        onClick={() => setVisible(false)}
        className="absolute top-2.5 md:top-3 right-2.5 md:right-3 text-[#A39171] hover:text-[#8C6208] transition-colors"
      >
        <X className="w-3.5 h-3.5 md:w-4 md:h-4" />
      </button>
      
      <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#8C6208] flex items-center justify-center shrink-0 shadow-inner">
        <Sparkles className="w-4 h-4 md:w-5 md:h-5 text-white" />
      </div>
      
      <div className="flex-1 pr-5 md:pr-6">
        <h3 className="text-[10px] md:text-xs font-black text-[#8C6208] uppercase tracking-wider mb-0.5">Sapaan ASA</h3>
        <p className="text-xs md:text-sm font-medium text-[#302621] leading-relaxed">
          {greeting}
        </p>
      </div>
    </div>
  );
}
